export default (context, data = {}) => {
    context.videos.forEach((item, index) => {
        if(data.index === index) {
            context.videos[index].status = !context.videos[index].status
            if(!item.status) {
                context.editElementStatus = false
                context.temporaryData = false
            } else {
                if(index === 0) {
                    context.buttonDelete = false
                } else {
                    context.buttonDelete = true
                }
                context.editElementStatus = true
                context.temporaryData = data
            }
        } else {
            context.videos[index].status = false
        }
    })
}